<template>
  <pt-related-label class="pt-related-label__withData" :loading="loading" :relatedList="relatedList" @submit="submit"
  :submitLoading="submit_loading" @deleteRelatedLabel="deleteRelatedLabel" ref="relatedLabel" @remoteRequest="remoteRequest" :resourse-labels="resourse_labels"></pt-related-label>
</template>

<script>
import PtRelatedLabel from './index'
export default {
  name: 'pt-related-label__withData',
  components: {
    'pt-related-label': PtRelatedLabel
  },
  data () {
    return {
      relatedList: [],
      loading: false,
      submit_loading: false,
      resourse_labels: []
    }
  },
  methods: {
    remoteRequest (val, next) {
      let data = {
        example: {
          name: val
        },
        pageableParam: {
          page: 0,
          size: 500
        }
      }
      this.$store.dispatch('labelListByName', data).then(res => {
        next(res.data)
        this.resourse_labels = res.data
      })
    },
    deleteRelatedLabel (val) {
      this.$store.dispatch('deleteRelatedLabel', val.id).then(res => {
        this.$message.success('删除关联标签成功')
        this.getRelatedLabels()
      }).catch(err => {
        this.$message.error(err || '删除关联标签失败')
      })
    },
    getRelatedLabels () {
      let data = {
        page: 0,
        size: 9999
      }
      this.loading = true
      this.$store.dispatch('getRelatedLabels', data).then(res => {
        this.loading = false
        res.forEach(item => {
          item.disabled = true
        })
        this.relatedList = res
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取关联标签失败')
      })
    },
    submit (val) {
      this.submit_loading = true
      this.$store.dispatch('updateRelatedLabel', val).then(res => {
        this.submit_loading = false
        this.$message.success('更新关联标签成功')
        this.$refs.relatedLabel.saveSuccess()
        this.getRelatedLabels()
      }).catch(err => {
        this.submit_loading = false
        this.$message.error(err || '更新关联标签失败')
      })
    }
  },
  created () {
    this.getRelatedLabels()
  }
}
</script>
